import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { moduleService } from "../services/course-module.service";

export const useGetCourseModule = (id) => {
  return useQuery({
    queryFn: () => moduleService.getModuleById(id),
    queryKey: ["get-module"],
    enabled: !!id,
  });
};

export const useUpdateCourseModule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => moduleService.editModule(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["get-module"],
      });
    },
  });
};

export const useDeleteModule = () => {
  return useMutation({
    mutationFn: (payload) => moduleService.deleteModuleById(payload),
  });
};

export const useGetCourseMaterials = (id) => {
  return useQuery({
    queryFn: () => moduleService.getCourseMaterials(id),
    queryKey: ["get-course-materials"],
    enabled: !!id,
  });
};

export const useDeleteMaterialById = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ courseId, materialId }) =>
      moduleService.deleteCourseMaterialById(courseId, materialId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["get-course-materials"],
      });

      queryClient.invalidateQueries({
        queryKey: ["get-course-materials", variables?.courseId],
      });
    },
  });
};
